import { useQuery } from '@tanstack/react-query';
import { useApi, useAuth } from '../../hooks';

interface MedicationCatalog {
  medications: string[];
  supplements: string[];
}

/**
 * Fetches the medication + supplement name catalog for the add-form typeahead
 * (GET /private/careos/pharmacy/catalog). Static reference data — production
 * replaces it with the Healthie API.
 */
export const useMedicationCatalog = () => {
  const { api } = useApi();
  const { isAuthenticated, loading, userToken } = useAuth();

  const { data, isLoading, isError } = useQuery<MedicationCatalog, Error>({
    queryKey: ['careos-medication-catalog', userToken],
    queryFn: () => api({ route: '/private/careos/pharmacy/catalog', token: userToken }),
    enabled: isAuthenticated && !loading && !!userToken,
    refetchOnWindowFocus: false,
  });

  return {
    medications: data?.medications ?? [],
    supplements: data?.supplements ?? [],
    isLoading,
    isError,
  };
};
